"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _spinner_blue = _interopRequireDefault(require("../../images/spinner_blue.gif"));
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var style = {
  "loading": "loading_indicator-module__loading___i6Pqs"
};
class LoadingIndicator extends _react.default.PureComponent {
  static propTypes = {
    textId: T.string,
    // TODO: remove from downstream and then here
    displayId: T.string,
    displayString: T.string,
    display: T.bool,
    className: T.string
  };
  static defaultProps = {
    display: true,
    displayId: 'au.loadingText'
  };
  renderLoader = (0, _bind.default)(_context = this.renderLoader).call(_context, this);
  renderLoader(msg) {
    const {
      className
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(style.loading, className)
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _spinner_blue.default,
      alt: msg
    }), msg);
  }
  render() {
    const {
      display,
      displayString,
      textId
    } = this.props;
    const displayId = this.props.displayId || textId;
    if (!display) return false;
    if (displayId) {
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: displayId,
        children: this.renderLoader
      });
    } else {
      return this.renderLoader(displayString);
    }
  }
}
exports.default = LoadingIndicator;